import types from './types';

const setScreenshot = (screenshot) => ({
  type: types.SET_SCREENSHOT,
  payload: {
    screenshot
  }
});

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setScreenshot
};
